<ion-content>
  <ion-item class="header safe-area-top">
    <p class="ion-padding-start fs-3 font500 text-color">
      {{ "Imported Flights" | translate }}
    </p>
    <ion-icon
      slot="end"
      name="close"
      size="small"
      class="primary-icon-color"
      (click)="closeModal()"
    ></ion-icon>
  </ion-item>
  <ng-container>
    <ion-grid class="border-btm">
      <div>
        <ion-row class="ion-text-center">
          <ion-col size="3">
            <ion-label class="fs-2 font500 black-text-color">{{
              "trips.calender_flights.flight_title" | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="3">
            <ion-label class="fs-2 font500 black-text-color">{{
              "trips.calender_flights.flight_from" | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="3">
            <ion-label class="fs-2 font500 black-text-color">{{
              "trips.calender_flights.flight_arrives" | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="3">
            <ion-label class="fs-2 font500 black-text-color">{{
              "trips.calender_flights.flight_date" | translate
            }}</ion-label>
          </ion-col>
        </ion-row>
      </div>
    </ion-grid>

    <ion-grid class="ion-no-padding">
      <div *ngFor="let item of flights">
        <flight-compact-card
          [flight]="item"
          (closeModal)="closeModal()"
        ></flight-compact-card>
      </div>
    </ion-grid>
  </ng-container>

  <ng-template #noFlight>
    <no-data message="no_data.no_results_mssg"></no-data>
  </ng-template>
</ion-content>
